import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const MetaTags = () => {
  const location = useLocation();
  const { i18n, t } = useTranslation();

  const locale = location.pathname.split('/')[1] || "en"; 

  if (i18n.language !== locale) {
    i18n.changeLanguage(locale);
  }

  const metaKeys = {
    [`/${locale}`]: "home",
    [`/${locale}/about`]: "about",
    [`/${locale}/services`]: "services",
    [`/${locale}/contact`]: "contact",
  };

  const currentMetaKey = metaKeys[location.pathname] || "home";

  return (
    <Helmet>
      <title>{t(`meta.${currentMetaKey}.title`)}</title>
      <meta name="description" content={t(`meta.${currentMetaKey}.description`)} />
      <meta name="keywords" content={t(`meta.${currentMetaKey}.tags`)} />
    </Helmet>
  );
};

export default MetaTags;
